import {concepts, StripeProduct} from "fearless-common";

const productToLabel: Record<StripeProduct, string> = {
    photo51: concepts.Photo51,
    eln: 'Eln',
    lims: 'Lims',
};

export function getProductLabel(productName: StripeProduct) {
    return productName in productToLabel ? productToLabel[productName] : productName;
}
